<div
    class="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0 pb-2 sm:pb-2 mb-4">
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('Land')"
        *ngIf="reportType !== 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Land</span>
    </button>

    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('BuiltUp')"
        *ngIf="reportType !== 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add BuiltUp</span>
    </button>
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new()"
        *ngIf="reportType === 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add</span>
    </button>
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="deleteSelectedRows()"
        *ngIf="selection.selected.length > 0">
        <mat-icon [svgIcon]="'delete_forever'"></mat-icon>
        <span class="ml-2 mr-1">All Delete</span>
    </button>
</div>
<div class="relative overflow-x-auto overflow-y-auto">
        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
            <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    <th scope="col" class="px-0 py-1 text-center w-5">
                        <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelectedCheckBox"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [color]="'primary'"
                            [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </th>
                    <th scope="col" class="px-0 py-1 w-10 text-center">Order</th>
                    <th scope="col" class="px-0 py-1 text-center w-30">Type</th>
                    <th scope="col" class="px-0 py-1 text-center w-30">Particular</th>
                    <th scope="col" class="px-0 py-1 text-center w-20">Width (In.Mt)</th>
                    <th scope="col" class="px-0 py-1 text-center w-20">Depth (In.Mt)</th>
                    <th scope="col" class="px-0 py-1 text-center w-20">Total (In.Sq.Mt)</th>
                    <th scope="col" class="px-0 py-1 text-center w-20">
                        <span class="sr-only">Actions</span>
                    </th>
                </tr>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                <ng-container *ngIf="approvedMeasurements$ | async as approvedMeasurements">
                    <ng-container *ngIf="approvedMeasurements.length; else noSiteMeasurement">
                        <tr class="border-b dark:border-gray-700"
                            *ngFor="let approvedMeasurement of approvedMeasurements; let i = index; trackBy: trackByFn"
                            cdkDrag>
                            <td class="px-1 py-1 text-center w-10">
                                <mat-checkbox [(checked)]="approvedMeasurement.selected" [color]="'primary'"
                                    (change)="updateCheckedList($event,approvedMeasurement)"></mat-checkbox>
                            </td>
                            <td class="px-1 py-1 p-1 w-10 text-center">{{approvedMeasurement.orderIndex}}</td>
                            <!-- <td class="px-0 py-1 text-center">{{approvedMeasurement.type}}</td> -->
                            <td class="px-1 py-1 text-center w-50">
                                <!-- {{approvedMeasurement.type}} -->
                                <mat-form-field class="w-full">
                                    <mat-select name="type" [placeholder]="'Select Type'"
                                        [disabled]="!approvedMeasurement.isEditing"
                                            [(ngModel)]="approvedMeasurement.type">
                                        <mat-option
                                            *ngIf="reportType !== 'FlatOrOfficeOrShop' && approvedMeasurement.selectedType != 'BuiltUp'"
                                            value="Land Area">Land
                                            Area</mat-option>
                                        <mat-option *ngIf="reportType === 'FlatOrOfficeOrShop'"
                                            value="Carpet Area">Carpet
                                            Area</mat-option>
                                        <mat-option
                                            *ngIf="reportType !== 'FlatOrOfficeOrShop' && approvedMeasurement.selectedType != 'Land'"
                                            value="Builtup Area">Builtup Area</mat-option>
                                        <mat-option
                                            *ngIf="reportType !== 'FlatOrOfficeOrShop' && approvedMeasurement.selectedType != 'Land'"
                                            value="Permissble Built up area as per prevailing building bye laws"
                                            class="pl-2">Permissble Built
                                            up area as per prevailing building bye laws</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>

                            <td class="px-1 py-0 text-center w-30">

                                <mat-form-field class="w-full">
                                    <input type="text" matInput [(ngModel)]="approvedMeasurement.particular" (ngModelChange)="particularValueChange($event)"
                                        [matAutocomplete]="autoParticular" [readonly]="!approvedMeasurement.isEditing"
                                        required>
                                    <mat-autocomplete #autoParticular="matAutocomplete"
                                        [displayWith]="displayOptionsFn(options)">
                                        <mat-option *ngFor="let option of filteredOptions | async"
                                            [value]="option.name">
                                            {{option.name}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>

                            <td class="px-1 py-0 text-center w-10">
                                <mat-form-field class="w-full">
                                    <input matInput class="px-1 py-0 border rounded text-right" type="number"
                                        [(ngModel)]="approvedMeasurement.width"
                                        (ngModelChange)="calculateTotal(approvedMeasurement)"
                                        [readonly]="!approvedMeasurement.isEditing" />
                                </mat-form-field>

                            </td>

                            <td class="px-1 py-0 text-center w-10">
                                <mat-form-field class="w-full">
                                    <input matInput class="border rounded text-right" type="number"
                                        [(ngModel)]="approvedMeasurement.depth"
                                        [readonly]="!approvedMeasurement.isEditing"
                                        (ngModelChange)="calculateTotal(approvedMeasurement)" />
                                </mat-form-field>
                            </td>

                            <td class="px-1 py-1 text-center w-10">
                                <mat-form-field class="w-full">
                                    <input matInput class="px-1 py-0 border rounded text-right"
                                        [(ngModel)]="approvedMeasurement.total" />
                                </mat-form-field>
                            </td>

                            <td class="px-1 py-1 flex items-center w-10">
                                <button class="ml-2" mat-icon-button (click)="save(approvedMeasurement)"
                                    *ngIf="approvedMeasurement.isEditing">
                                    <mat-icon svgIcon="save"></mat-icon>
                                </button>
                                <button class="ml-2" mat-icon-button *ngIf="!approvedMeasurement.isEditing">
                                    <mat-icon svgIcon="edit" (click)="toggleEdit(i)"></mat-icon>
                                </button>
                                <button class="ml-2" mat-icon-button *ngIf="approvedMeasurement.isEditing">
                                    <mat-icon svgIcon="close" (click)="cancelNewRow(i)"></mat-icon>
                                </button>
                                <button class="ml-2" mat-icon-button
                                    *ngIf="approvedMeasurement.id!==0 && !approvedMeasurement.isEditing">
                                    <mat-icon svgIcon="delete_forever"
                                        (click)="delete(approvedMeasurement.id)"></mat-icon>
                                </button>

                            </td>
                        </tr>
                    </ng-container>
                </ng-container>

                <ng-template #noSiteMeasurement>
                    <tr>
                        <td colspan="4" class="text-sm dark:text-gray-400 font-semibold tracking-tight text-center">
                            There
                            are no
                            Approved Measurement!</td>

                    </tr>
                </ng-template>
            </tbody>
            <tfoot>
                <tr class="font-semibold text-gray-900 dark:text-white">
                    <th class="px-6 py-3"></th>
                    <th scope="row" class="px-6 py-3 text-base">Total(In Sq.Mt)</th>
                    <td class="px-6 py-3"></td>
                    <td class="px-3 py-3">
                        <mat-form-field class="w-full pr-2" appearance="outline">
                            <mat-label>Area (In.Sq.Mt)</mat-label>
                            <input matInput [(ngModel)]="report.approvedArea" class="text-right" readonly>
                        </mat-form-field>
                    </td>
                    <td class="px-3 py-3">
                        <mat-form-field class="w-full pr-2" appearance="outline">
                            <mat-label>BuiltUp (In Sq.Mt)</mat-label>
                            <input matInput [(ngModel)]="report.approvedBuiltUp" [value]="report.approvedBuiltUp" class="text-right"
                                [readonly]="reportType === 'LandAndBuilding'">
                        </mat-form-field>
                    </td>
                    <td class="px-3 py-3">
                        <mat-form-field class="w-full pr-2" appearance="outline">
                            <mat-label>SBU (In Sq.Mt)</mat-label>
                            <input matInput [(ngModel)]="report.approvedSuperBuiltUp" class="text-right"
                                [value]="report.approvedSuperBuiltUp" [readonly]="reportType === 'LandAndBuilding'">
                        </mat-form-field>
                    </td>
                </tr>
            </tfoot>
        </table>
</div>
